import { Stack, Typography } from "@mui/material";
import { RHFTextField } from "src/components/hook-form";
import useLocales from "src/hooks/useLocales";

export default function AppNameInput() {
	const { translate } = useLocales();

	return (
		<Stack gap={1}>
			<Typography variant='subtitle1' fontSize={15}>
				{translate("new_app.app_name")}
			</Typography>
			<Typography variant='subtitle1' fontSize={12} color='text.secondary'>
				{translate("new_app.app_name_description")}
			</Typography>
			<RHFTextField
				autoFocus
				fullWidth
				label={translate("new_app.add_a_name")}
				margin='dense'
				name='name'
				type='text'
			/>
		</Stack>
	);
}
